module.exports = __webpack_public_path__ + "statics/img/yhz4m.d7adc8bb.png";